import React from 'react';
import { Link } from '../Link';
import { CompanyLogo } from '../CompanyLogo';
import { CompanyName } from '../CompanyName';
import { shouldLinkCompanyProfile } from '../../utils/company/should-link-company-profile';
import { HitCompanyInsightsCueLink } from './HitCompanyInsightsCueLink';

export function HitCompanyColumn(props: {
  companyProfileUrl?: string;
  companyId: string;
  companyNameDisplay?: string;
  registryCompanyFormDescription?: string | null;
  isTyomarkkinatori: boolean;
  index: number;
  locale: string;
  ariaLabel: string;
  title: string;
  insightsCue: string;
}): React.ReactElement {
  const hasCompanyProfileLink = shouldLinkCompanyProfile({
    companyId: props.companyId,
    isTyomarkkinatori: props.isTyomarkkinatori,
  });
  const logoNameBlock = (
    <>
      <span className="hit-card__company-logo-wrap">
        <CompanyLogo
          companyName={props.companyId || ''}
          initialsSourceName={props.companyNameDisplay ?? props.companyId}
          registryCompanyFormDescription={props.registryCompanyFormDescription}
          isTyomarkkinatori={props.isTyomarkkinatori}
          size={56}
          loading={props.index < 3 ? 'eager' : 'lazy'}
        />
      </span>
      {props.companyId ? (
        <span className="hit-card__company-mobile underline decoration-from-font underline-offset-2 group-hover:decoration-[#3B5E45] dark:group-hover:decoration-[#98CFA8]">
          <CompanyName
            name={props.companyNameDisplay ?? props.companyId}
            className="font-bold text-xs md:text-sm text-[#3D3529] dark:text-[#C4A882]"
          />
        </span>
      ) : null}
    </>
  );

  const insightsInLeading =
    props.companyProfileUrl && hasCompanyProfileLink ? (
      <HitCompanyInsightsCueLink
        variant="in-leading"
        href={props.companyProfileUrl}
        locale={props.locale}
        title={props.title}
        insightsCue={props.insightsCue}
        tabIndex={-1}
        ariaHidden
      />
    ) : null;

  if (props.companyProfileUrl && hasCompanyProfileLink) {
    return (
      <div className="hit-card__leading-stack">
        <Link
          href={props.companyProfileUrl}
          locale={props.locale}
          className="hit-card__logo-mobile hit-card__company-link group"
          aria-label={props.ariaLabel}
          title={props.title}
        >
          {logoNameBlock}
        </Link>
        {insightsInLeading}
      </div>
    );
  }

  return (
    <div className="hit-card__leading-stack hit-card__leading-stack--no-profile-link">
      <div className="hit-card__logo-mobile">{logoNameBlock}</div>
    </div>
  );
}
